// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__jW_nX"};